import React from "react";
import { HTextarea } from "../../../validation/HForm";
import { StatusButton } from "../components";
import {RequestFieldKeys, RequestFields} from "../constants/constants";

export const renderActionButtons = ({
                                        status,
                                        buttons,
                                        disabled,
                                        handleStatusChange,
                                        additionalDisabledConditions = {}
                                    }) => {
    const filteredButtons = buttons.filter(({ statuses }) =>
        statuses ? statuses.includes(status) : true
    );

    return filteredButtons.map(({ label, key, type }, index) => {
        const isSpecificallyDisabled = additionalDisabledConditions[key] || false;
        const isButtonDisabled = disabled || isSpecificallyDisabled;

        return (
            <StatusButton
                key={index}
                type={type}
                label={label}
                status={key ?? "primary"}
                size="md"
                disabled={isButtonDisabled}
                onClick={() => handleStatusChange(key)}
            />
        );
    });
};

export const renderCommentFields = (
    showCommentFields,
    label,
    commentValue,
    handleCommentChange,
    excludedStatuses = [RequestFieldKeys.DESIRED_TERM, RequestFieldKeys.DESIRED_AMOUNT],
    name
) => {
  const isCommentFieldVisible =
    showCommentFields && (!Object.keys(RequestFields).includes(label) || excludedStatuses.includes(label));

  return isCommentFieldVisible ? (
      <div className="comment">
        <HTextarea
            className="input"
            placeholder="Введите комментарий"
            rows="3"
            cols="10"
            name={name}
            id={`comment-${label}`}
            value={commentValue || ""}
            onChange={handleCommentChange}
        />
      </div>
  ) : null;
};